//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('sop', {
//        templateUrl: 'views/components/views/sop/sop.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'sopService', function ($stateParams, stateService, translateService, modalService, sopService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let sopKeyno = $stateParams.sop_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListFieldTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            let loadEdit = function () {
//                sopService.getEdit({ sop_keyno: sopKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            let loadFieldTypes = function () {
//                sopService.listFieldTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListFieldTypes);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                sopService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadFieldTypes();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
